import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

import useHeatmapLayer from 'hooks/Meteorology/Agro/WaterBalanceSequential/Maps/useHeatmapLayer';
import useHeatmapLegend from 'hooks/Meteorology/Agro/WaterBalanceSequential/Maps/useHeatmapLegend';

import type { WBSequentialMapData } from 'types/Meteorology/Agro/WaterBalanceSequential/Maps/getMapData';
import useSpinnerControl from 'hooks/Meteorology/Agro/WaterBalanceSequential/Maps/useSpinnerControl';
import useVariables from 'hooks/Meteorology/Agro/WaterBalanceSequential/Maps/useVariables';

export default function Heatmap({
  heatmapPoints,
  isLoading,
}: {
  heatmapPoints: WBSequentialMapData;
  isLoading: boolean;
}) {
  const map = useMap();
  const { config } = useVariables();
  const heatmapLayer = useHeatmapLayer(heatmapPoints, config);
  const spinnerControl = useSpinnerControl(isLoading);
  const legend = useHeatmapLegend(heatmapPoints);

  useEffect(() => {
    if (!map || !heatmapLayer || !legend) return () => {};

    map.addControl(legend);
    map.addLayer(heatmapLayer);
    return () => {
      map.removeLayer(heatmapLayer);
      map.removeControl(legend);
    };
  }, [map, heatmapLayer, legend]);

  useEffect(() => {
    if (!map || !spinnerControl) return () => {};

    map.addControl(spinnerControl);
    return () => { map.removeControl(spinnerControl); };
  }, [map, spinnerControl]);

  return null;
}
